import {
    FETCH_ORG_ACCESS_DATA_REQUEST,
    UPDATE_ORG_ACCESS_DATA_REQUEST
} from './actionConstants';

export const fetchOrgAccessData = payload => ({
    type: FETCH_ORG_ACCESS_DATA_REQUEST
})

export const updateOrgAccesssData = payload => ({
    type: UPDATE_ORG_ACCESS_DATA_REQUEST,
    payload
})
